import axios from "../../../axios";

export default {
    getAllSubmissions(data) {
        return axios.get('my-data/pois/submissions/all-submissions', {params: data})
    },
    createNewSubmission(data) {
        return axios.post('my-data/pois/submissions/create-submission', data)
    },
    createNewBrand(data) {
        return axios.post('my-data/pois/submissions/create-brand', data)
    },
    getAllBrands() {
        return axios.get('my-data/pois/submissions/all-brands')
    },
    getAllCategories() {
        return axios.get('my-data/pois/submissions/all-categories')
    },
    getAllSegments() {
        return axios.get('my-data/pois/submissions/all-segments')
    },
    deleteSubmission(data) {
        return axios.post('my-data/pois/submissions/delete', data)
    },
    uploadSubmissionFile(data, headers) {
        return axios.post('my-data/pois/submissions/file-upload', data, headers)
    },
    removeSubmissionFile(data) {
        return axios.post('my-data/pois/submissions/file-remove', data)
    },
    getAllCompanyLocations(data) {
        return axios.get('my-data/pois/my-pois/all-locations', {params: data})
    },
    getAllCountries() {
        return axios.get('my-data/pois/my-pois/all-countries')
    },
    getAllTaxonomies(data) {
        return axios.get('my-data/pois/taxonomies/all-taxonomies', {params: data})
    }
}